export const TERRITORY_ASSIGNMENT_TERRITORIES = "TerritoryAssignmentTerritories";
export const TERRITORY_ASSIGNMENT_TERRITORIES_LOADING = "TerritoryAssignmentTerritoriesLoading";

export const TERRITORY_ASSIGNMENT_USERS = "TerritoryAssignmentUsers";
export const TERRITORY_ASSIGNMENT_USERS_LOADING = "TerritoryAssignmentUsersLoading";
